exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-content-container[data-v-040ce9dd]{margin-top:20px}", ""]);

// exports
